export default __webpack_public_path__ + "static/media/Circle170.147d3feb.svg";